import api from "../../../services/api";

const BASE_PATH = "/api/v1/performance";

export const buildPerformanceUrl = (path = "") => `${BASE_PATH}${path}`;

export const unwrapListResponse = (response) => {
  const rows = Array.isArray(response?.data)
    ? response.data
    : Array.isArray(response?.data?.rows)
      ? response.data.rows
      : [];

  const meta = response?.meta || response?.data?.meta || {};

  return {
    rows,
    meta: {
      page: Number(meta?.page) || 1,
      limit: Number(meta?.limit) || rows.length || 10,
      total: Number(meta?.total) || rows.length,
      pages: Number(meta?.pages) || 1,
    },
    raw: response,
  };
};

export const unwrapDetailResponse = (response) => {
  if (!response) {
    return null;
  }

  if (response?.data !== undefined) {
    return response.data;
  }

  return response;
};

export const getRequest = async (path, config = {}) => {
  const res = await api.get(buildPerformanceUrl(path), config);
  return res.data;
};

export const postRequest = async (path, body = {}, config = {}) => {
  const res = await api.post(buildPerformanceUrl(path), body, config);
  return res.data;
};

export const putRequest = async (path, body = {}, config = {}) => {
  const res = await api.put(buildPerformanceUrl(path), body, config);
  return res.data;
};

export const deleteRequest = async (path, config = {}) => {
  const res = await api.delete(buildPerformanceUrl(path), config);
  return res.data;
};
